interface SurveyPayload {
  q1: string | null;
  q2?: string[];
  q2Other?: string;
  q3?: string[];
  q3Other?: string;
  q4?: string[];
  q4Other?: string;
}

export const submitSurvey = async (payload: SurveyPayload): Promise<Response> => {
  return fetch('/api/survey', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
};
